import { createLucideIcon } from 'lucide-react';

export const BranchPath = createLucideIcon('BranchPath', [
  [
    'path',
    {
      key: 'path-1',
      d: 'm22 15 1 1v5l-1 1h-5a1 1 0 0 1 0-2h4v-4l1-1Zm0-13 1 1v5a1 1 0 0 1-2 0V4h-4a1 1 0 1 1 0-2h5Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-2',
      d: 'M22 2v2l-8 8a5 5 0 0 1-3 1H3a1 1 0 1 1 0-2h8a3 3 0 0 0 2-1l8-8h1Zm0 20h-1l-6-6a1 1 0 0 1 1-2l6 6v2Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
